var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-4"},_vm._l((_vm.league_players),function(player){return _c('league-player-card',{key:player.id + '_player',attrs:{"player":player}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }